import moment from "moment";
import thousands from "thousands";

const totalTicketAmount = (ticketTypeVariants) => {
  let totalAmount = 0;
  const amounts = ticketTypeVariants?.forEach((item) => {
    totalAmount += item?.amount * item?.selectedQuantity || 0;
  });
  return totalAmount;
};

const calculateNumberOfTickets = (ticketTypeVariants) => {
  let numberOfTickets = 0;
  const tickets = ticketTypeVariants?.forEach((item) => {
    numberOfTickets += item?.selectedQuantity || 0;
  });
  return numberOfTickets;
};

export const calculateDiscount = (
  data,
  ticketTypeVariants,
  type = "event",
  isAuthenticated
) => {
  const pricing = data?.eventPricing;
  const discount = data?.eventDiscount;
  const allTicketsAmount = totalTicketAmount(ticketTypeVariants);
  const totalTickets = calculateNumberOfTickets(ticketTypeVariants);
  let discountAmount = 0;
  const dataforEach = discount?.forEach((item) => {
    if (item?.forMemberOnly && !isAuthenticated) return;
    if (item?.discount_type === "date") {
      const startDate = moment(item?.start_date);
      const endDate = moment(item?.end_date);
      const currentDate = moment();

      if (currentDate.isBetween(startDate, endDate, null, "[]")) {
        if (item?.price_type === "fixed") {
          discountAmount += item?.value;
        } else {
          discountAmount =
            (allTicketsAmount * item?.value) / 100 + discountAmount;
        }
      } else {
      }
    } else if (
      item?.discount_type === "amount" &&
      allTicketsAmount >= item?.amount
    ) {
      if (item?.price_type === "fixed") {
        discountAmount += item?.value;
      } else {
        discountAmount =
          (allTicketsAmount * item?.value) / 100 + discountAmount;
      }
    } else if (
      item?.discount_type === "quantity" &&
      item?.quantity &&
      totalTickets >= item?.quantity
    ) {
      if (item?.price_type === "fixed") {
        discountAmount += item?.value;
      } else {
        discountAmount =
          (allTicketsAmount * item?.value) / 100 + discountAmount;
      }
    }
  });

  const totalAfterDiscount =
    allTicketsAmount > 0
      ? (Math.max(0, +allTicketsAmount - +discountAmount)).toFixed(2)
      : "0.00";
  return {
    totalAfterDiscount,
    discountTotal:
      discountAmount < 0
        ? `-$${Math.abs(discountAmount).toFixed(2)}`
        : `-$${discountAmount.toFixed(2)}`,
    totalDiscount: discountAmount,
  };
};
export const calculateTotalPayment = (
  data,
  ticketTypeVariants,
  type,
  isAuthenticated
) => {
  const totalPayment = calculateDiscount(
    data,
    ticketTypeVariants,
    type,
    isAuthenticated
  )?.totalAfterDiscount?.replace(/,/g, "");
  return (+totalPayment).toFixed(2);
};

export const calculateTotalPaymentWithCVFee = (
  data,
  ticketTypeVariants,
  type,
  isAuthenticated
) => {
  const totalPayment = calculateDiscount(
    data,
    ticketTypeVariants,
    type,
    isAuthenticated
  )?.totalAfterDiscount?.replace(/,/g, "");
  return (+totalPayment).toFixed(2);
};

export const calculateDueDiscount = (
  totalAmount,
  discounts,
  numberOfTickets,
  isAuthenticated
) => {
  let discountAmount = 0;

  const dataforEach = discounts?.forEach((item) => {
    if (item?.forMemberOnly && !isAuthenticated) return;
    if (item?.discount_type === "date") {
      const startDate = moment(item?.start_date);
      const endDate = moment(item?.end_date);
      const currentDate = moment();

      if (currentDate.isBetween(startDate, endDate, null, "[]")) {
        if (item?.price_type === "fixed") {
          discountAmount += item?.value;
        } else {
          discountAmount = (totalAmount * item?.value) / 100 + discountAmount;
        }
      } else {
      }
    } else if (
      item?.discount_type === "amount" &&
      totalAmount >= item?.amount
    ) {
      if (item?.price_type === "fixed") {
        discountAmount += item?.value;
      } else {
        discountAmount = (totalAmount * item?.value) / 100 + discountAmount;
      }
    } else if (
      item?.discount_type === "quantity" &&
      item?.quantity &&
      numberOfTickets?.length >= item?.quantity
    ) {
      if (item?.price_type === "fixed") {
        discountAmount += item?.value;
      } else {
        discountAmount = (totalAmount * item?.value) / 100 + discountAmount;
      }
    }
  });

  const totalAfterDiscount =
    totalAmount > 0 ? Math.max(0, +totalAmount - +discountAmount) : 0;
  return {
    totalAfterDiscount,
    discountTotal: discountAmount,
  };
};
